<nb-card class="modal-full" [nbSpinner]="loading" nbSpinnerSize="medium" nbSpinnerStatus="success" >
  <nb-card-header>
    Update object from template
  </nb-card-header>
  <nb-card-body>
    <table *ngIf="!loading && gamesChanges.length>0">
      <tr>
        <th class="image">Img Game</th>
        <th>&nbsp;</th>
        <th class="image">Img Template</th>

        <th> | </th>

        <th class="labels">Label Game</th>
        <th>&nbsp;</th>
        <th class="labels">Label Template</th>

        <th> | </th>

        <th class="description">Description Game</th>
        <th>&nbsp;</th>
        <th class="description">Description Template</th>
        
        <th> | </th>
        <th class="description">external Url Game</th>
        <th>&nbsp;</th>
        <th class="description">external Url Template</th>
        
        <th> | </th>
        <th class="description">external Url ELabel Game</th>
        <th>&nbsp;</th>
        <th class="description">external Url Label Template</th>

        <th> | </th>
        <th class="labels">External Url In New Window Game</th>
        <th>&nbsp;</th>
        <th class="labels">External Url In New Window Template</th>
        
        <th> | </th>
        <th class="description">external Url By Language Game</th>
        <th>&nbsp;</th>
        <th class="description">external Url By Language Template</th>
        
        <th> | </th>
        <th class="image">object Pic Game</th>
        <th>&nbsp;</th>
        <th class="image">object Pic Template</th>

        <th class="object-action">Action</th>
      </tr>
      <ng-template ngFor let-game="$implicit" [ngForOf]="gamesChanges" let-i="index">
        <tr class="object">
          <td colspan="3" class="title-object" (click)="toggleShowDetailGame(i)">
            {{game.name | txtTranslate }}
          </td>
          <td colspan="27"> </td>
          <td colspan="2" class="arrow-button" (click)="toggleShowDetailGame(i)">
            <nb-icon *ngIf="!gameVisibly[i]" icon="arrow-ios-downward-outline"></nb-icon>
            <nb-icon *ngIf="gameVisibly[i]" icon="arrow-ios-upward-outline"></nb-icon>
          </td>
        </tr>
        <tbody [@slideInOut] *ngIf="!gameVisibly[i]">
          <tr *ngFor="let change of game?.changes; let j = index">
            <!-- image game -->
            <td class="image">
              <img nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="gameMissionId: {{change.gameMission}}, gameSuccessMissionId : {{change.gameSuccessMission}}" [src]="change.objectGame?.pictureUrl ? change.objectGame?.pictureUrl : 'https://place-hold.it/50x50&text='" style="width:70px;height:auto;">
              <small class="text-danger" *ngIf="change.objectGame?.pictureLastUpdate !== change.template?.pictureLastUpdate">{{change.objectGame?.pictureLastUpdate | date: 'dd/MM/YYYY HH:mm'}}</small>
            </td>
            <td>=></td>
            <!-- image template -->
            <td class="image">
              <img nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}" 
              [src]="change.template?.pictureUrl ? change.template?.pictureUrl : 'https://place-hold.it/50x50&text='" style="width:70px;height:auto;">
              <small class="text-danger" *ngIf="change.objectGame?.pictureLastUpdate !== change.template?.pictureLastUpdate">{{change.template?.pictureLastUpdate | date: 'dd/MM/YYYY HH:mm'}}</small>
            </td>
  
            <td>|</td>
            <!-- label game -->
            <td class="labels" *ngIf="change.objectGame?.labels[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="gameMissionId: {{change.gameMission}}, gameSuccessMissionId : {{change.gameSuccessMission}}" class="text" [innerHTML]='getDiffAttributes(change.template?.labels[currentLang], change.objectGame?.labels[currentLang],"to")'></div>
            </td>
            <td class="labels" *ngIf="!change.objectGame?.labels[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="gameMissionId: {{change.gameMission}}, gameSuccessMissionId : {{change.gameSuccessMission}}" class="text" style="color:grey;"> Empty Label </div>
            </td>
            <td>=></td>
            <!-- label template -->
            <td class="labels" *ngIf="change.template?.labels[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}" class="text" [innerHTML]='getDiffAttributes(change.objectGame?.labels[currentLang], change.template?.labels[currentLang],"from")'> </div>
            </td>
            <td class="labels" *ngIf="!change.template?.labels[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}" class="text" style="color:grey;"> Empty Label </div>
            </td>
  
            <td>|</td>
            <!-- description game -->
            <td class="description" *ngIf="change.objectGame?.description[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="gameMissionId: {{change.gameMission}}, gameSuccessMissionId : {{change.gameSuccessMission}}" class="text" [innerHTML]='getDiffAttributes(change.template?.description[currentLang], change.objectGame?.description[currentLang],"to")'></div>
            </td>
            <td class="description" *ngIf="!change.objectGame?.description[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="gameMissionId: {{change.gameMission}}, gameSuccessMissionId : {{change.gameSuccessMission}}" class="text" style="color:grey;"> Empty Description </div>
            </td>
            <td>=></td>
            <!-- description template -->
            <td class="description" *ngIf="change.template?.description[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" class="text" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" [innerHTML]='getDiffAttributes(change.objectGame?.description[currentLang], change.template?.description[currentLang],"from")'></div>
            </td>
            <td class="description" *ngIf="!change.template?.description[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text" style="color:grey;"> Empty Description </div>
            </td>
  
          <!-- externalUrl -->
            <td>|</td>
            <!-- externalUrl game -->
            <td *ngIf="change.objectGame?.externalUrl">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text url" [innerHTML]='getDiffAttributes(change.template?.externalUrl, change.objectGame?.externalUrl,"from")'> </div>
            </td>
            <td *ngIf="!change.objectGame?.externalUrl">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text url" style="color:grey;"> Empty externalUrl </div>
            </td>
  
            <td>=></td>
            <!-- externalUrl template -->
            <td *ngIf="change.template?.externalUrl">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text url" [innerHTML]='getDiffAttributes(change.objectGame?.externalUrl, change.template?.externalUrl,"from")'> </div>
            </td>
            <td *ngIf="!change.template?.externalUrl">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text url" style="color:grey;"> Empty externalUrl </div>
            </td>
  
          <!-- externalUrlLabel -->
            <td>|</td>
            <!-- externalUrlLabel game -->
            <td *ngIf="change.objectGame?.externalUrlLabel && change.objectGame?.externalUrlLabel[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text url" [innerHTML]='getDiffAttributes(change.template?.externalUrlLabel[currentLang], change.objectGame?.externalUrlLabel[currentLang],"from")'> </div>
            </td>
            <td *ngIf="!change.objectGame?.externalUrlLabel || !change.objectGame?.externalUrlLabel[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text url" style="color:grey;"> Empty externalUrl Label </div>
            </td>
            <td>=></td>
            <!-- externalUrlLabel template -->
            <td *ngIf="change.template?.externalUrlLabel && change.template?.externalUrlLabel[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text url" [innerHTML]='getDiffAttributes(change.objectGame?.externalUrlLabel[currentLang], change.template?.externalUrlLabel[currentLang],"from")'> </div>
            </td>
            <td *ngIf="!change.template?.externalUrlLabel || !change.template?.externalUrlLabel[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text url" style="color:grey;"> Empty externalUrl Label </div>
            </td>
  
          <!-- isExternalUrlInNewWindow -->
            <td>|</td>
            <!-- isExternalUrlInNewWindow game -->
            <td class="labels" *ngIf="change.objectGame?.isExternalUrlInNewWindow">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text">{{ change.objectGame?.isExternalUrlInNewWindow}} </div>
            </td>
            <td class="labels" *ngIf="!change.objectGame?.isExternalUrlInNewWindow">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text" style="color:grey;"> Empty External Url In New Window </div>
            </td>
            <td>=></td>
            <!-- externalUrlLabel template -->
            <td class="labels" *ngIf="change.template?.isExternalUrlInNewWindow">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text">{{change.template?.isExternalUrlInNewWindow}} </div>
            </td>
            <td class="labels" *ngIf="!change.template?.isExternalUrlInNewWindow">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text" style="color:grey;"> Empty External Url In New Window </div>
            </td>
  
          <!-- externalUrlByLanguage -->
            <td>|</td>
            <!-- externalUrlByLanguage game -->
            <td *ngIf="change.objectGame?.externalUrlByLanguage && change.objectGame?.externalUrlByLanguage[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text url" [innerHTML]='getDiffAttributes(change.template?.externalUrlByLanguage[currentLang], change.objectGame?.externalUrlByLanguage[currentLang],"from")'> </div>
            </td>
            <td *ngIf="!change.objectGame?.externalUrlByLanguage || !change.objectGame?.externalUrlByLanguage[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text url" style="color:grey;"> Empty external Url By Language </div>
            </td>
            <td>=></td>
            <!-- externalUrlByLanguage template -->
            <td *ngIf="change.template?.externalUrlByLanguage && change.template?.externalUrlByLanguage[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}"
              class="text url" [innerHTML]='getDiffAttributes(change.objectGame?.externalUrlByLanguage[currentLang], change.template?.externalUrlByLanguage[currentLang],"from")'> </div>
            </td>
            <td *ngIf="!change.template?.externalUrlByLanguage || !change.template?.externalUrlByLanguage[currentLang]">
              <div nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission }}" class="text url" style="color:grey;"> Empty external Url By Language </div>
            </td>
          
          <!-- objectPic -->
            <td>|</td>
            <!-- image game -->
            <td class="image">
              <img nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="gameMissionId: {{change.gameMission}}, gameSuccessMissionId : {{change.gameSuccessMission}}"
              *ngIf="change.objectGame?.objectPic"
              [src]="change.objectGame?.objectPic[this.languageService.currentLang] ? change.objectGame?.objectPic[this.languageService.currentLang].url : 'https://place-hold.it/50x50&text='" style="width:70px;height:auto;">
            </td>
            <td>=></td>
            <!-- image template -->
            <td class="image">
              <img nbTooltipTrigger="hover" nbTooltipStatus="info" nbTooltip="templateMissionId: {{change.templateMission}}, templateSuccessMissionId : {{change.templateSuccessMission}}" 
              *ngIf="change.template?.objectPic"
              [src]="change.template?.objectPic[this.languageService.currentLang] ? change.template?.objectPic[this.languageService.currentLang].url : 'https://place-hold.it/50x50&text='" style="width:70px;height:auto;">
            </td>
  
            <td class="object-action" *ngIf="change.template.id">
              <button *ngIf="change.objectGame?.description[currentLang] || change.objectGame?.pictureUrl || change.objectGame?.labels[currentLang]" class="save-btn" nbButton status="info" (click)="applyChanges(game.gameId, change.template, change.objectGame, i, j, 0)">Apply changes in game</button>
              <button *ngIf="!change.objectGame?.description[currentLang] && !change.objectGame?.pictureUrl && !change.objectGame?.labels[currentLang]" class="save-btn" nbButton status="success" (click)="applyChanges(game.gameId, change.template, change.objectGame, i, j, 0)">Create Object in game</button>
            </td>
            <td class="object-action" *ngIf="!change.template.id">
              <div class="text-action">        
                <button nbButton status="danger" class="save-btn" (click)="deleteObject(change.objectGame, i, j)">Delete Object in game</button>
              </div>
            </td>
          </tr>
        </tbody>
      </ng-template>
    </table>
    <div class="text-center" *ngIf="!loading && gamesChanges.length==0"> No changes found</div>
  </nb-card-body>
  <nb-card-footer>
    <div class="row">
      <button class="cancel" nbButton status="danger" (click)="close()">Cancel</button>
      <button class="success" nbButton status="success" (click)="applyAllChanges()" *ngIf="!loading && gamesChanges.length>0">Apply all changes</button>
    </div>
  </nb-card-footer>
</nb-card>
